module.exports = __webpack_public_path__ + "img/chord-label-C.3d409b2b.png";